//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './css/shop.css';

export default class Shop extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {};
  };

  
  
  async componentDidMount() {
		document.title = "Shop | Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var js = document.createElement("script");
		js.type = "text/javascript";
		js.src = "https://mix365.myspreadshop.co.uk/shopfiles/shopclient/shopclient.nocache.js";
		document.body.appendChild(js);
	}

	componentWillUnmount() {
	}


	

	render() {
		
		return (
			<>
				<div className="contact">
					<div className="contact-background"></div>
				</div>

				

							<Row className="gx-0">
								<Col className="contact-header">
									<h1>Mix365 Shop</h1>
								</Col>
							</Row>
							<Row className="gx-0">
						<Col>
							<div id="myShop">
								<a href="https://mix365.myspreadshop.co.uk">mix365</a>
							</div>
						</Col>
					</Row>
				
				
				
					
				
			</>
		);
	}
}
